"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _input = require("./input");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "disabled", "helpText", "id", "label", "maxLength", "name", "normalizeValue", "parseValue"],
    _excluded2 = ["error", "meta", "onBlur", "onChange", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `StyledLabel` styled component.
 */
var StyledLabel = (0, _styledComponents["default"])(_fieldsStyledComponents.Label).withConfig({
  displayName: "textarea__StyledLabel",
  componentId: "sc-av3nhs-0"
})(["background-color:", ";", ""], (0, _styles.color)('gray300'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('gray100'))));
/**
 * `StyledMaxLength` styled component.
 */

var StyledMaxLength = (0, _styledComponents["default"])(_fieldsStyledComponents.MaxLength).withConfig({
  displayName: "textarea__StyledMaxLength",
  componentId: "sc-av3nhs-1"
})(["bottom:0;padding-left:0;padding-right:0;padding-top:0;position:absolute;right:14px;"]);
/**
 * `Textarea` component.
 */

function Textarea(props, ref) {
  var _value$length;

  var className = props.className,
      disabled = props.disabled,
      helpText = props.helpText,
      id = props.id,
      label = props.label,
      maxLength = props.maxLength,
      name = props.name,
      _props$normalizeValue = props.normalizeValue,
      normalizeValue = _props$normalizeValue === void 0 ? _input.defaultNormalizeValue : _props$normalizeValue,
      parseValue = props.parseValue,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      onBlur = _useField.onBlur,
      onChange = _useField.onChange,
      value = _useField.value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _ref = meta || {},
      active = _ref.active;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  function handleChange(event) {
    var value = event.target.value;
    var parsedValue = parseValue ? parseValue(value) : value;
    onChange(!(0, _isEmpty2["default"])(parsedValue) ? parsedValue : undefined);
  }

  function handleBlur(event) {
    var value = event.target.value;
    var parsedValue = parseValue ? parseValue(value) : value;
    var normalizedValue = normalizeValue(parsedValue);
    onChange(!(0, _isEmpty2["default"])(normalizedValue) ? normalizedValue : undefined);
    onBlur(event);
  }

  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: isDisabled,
    hasAlert: hasError || !!helpText
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormControlWrapper, {
    disabled: isDisabled,
    hasError: hasError,
    hasFocus: active
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    disabled: isDisabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    isFloating: Boolean(value) || active
  }, label), /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormControl, _extends({
    as: 'textarea',
    disabled: isDisabled,
    id: id !== null && id !== void 0 ? id : name,
    name: name,
    ref: ref,
    value: value || ''
  }, rest, fieldProps, {
    onBlur: handleBlur,
    onChange: handleChange
  })), maxLength && /*#__PURE__*/_react["default"].createElement(StyledMaxLength, {
    disabled: isDisabled,
    hasError: (error === null || error === void 0 ? void 0 : error.rule) === 'maxLength'
  }, "".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/").concat(maxLength))), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}
/**
 * Forwarded `Textarea`.
 */


var ForwardedTextarea = /*#__PURE__*/(0, _react.forwardRef)(Textarea);
/**
 * Export `Textarea` component.
 */

exports.Textarea = ForwardedTextarea;